import { render } from "./WeeklyRewards.vue?vue&type=template&id=2d6a2e24"
import script from "./WeeklyRewards.vue?vue&type=script&lang=js"
export * from "./WeeklyRewards.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__